<template>
  <div class="footer" id="footer">
    <div class="link-wrapper section">
      <div v-if="isZhLocale" class="other">
        <div class="text">{{ $t('siteFooter.followUs') }}</div>
        <div>
          <a class="imgWrapper" href="javascript:void(0)">
            <img class="link" src="https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/1e82fc36-991a-4aba-b2bb-df6f27cf305d.jpg" alt="wechat-code" />
            <img class="item wechat" src="https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/index-weixin.png" alt="wechat" />
          </a>
          <a class="imgWrapper" href="javascript:void(0)">
            <img class="link" src="https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/douyin_link.png" alt="douyin-code" />
            <img class="item douyin" src="https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/index-douyin.png" alt="douyin" />
          </a>
          <a href="https://weibo.com/u/7307149621" target="_blank" class="imgWrapper" rel="noopener noreferrer">
            <img class="item weibo" src="https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/index-weibo.png" alt="weibo" />
          </a>
        </div>
      </div>

      <div class="border"></div>

      <div class="left">
        <div v-if="isZhLocale" class="ljxc item">
          <div class="h1">{{ $t('siteFooter.recruit') }}</div>
          <a href="https://www.xchr-group.com/joinus.html" target="_blank" class="h2">{{ $t('siteFooter.socialRecruit') }}</a>
          <a href="https://www.xchr-group.com/joinus.html" target="_blank" class="h2">{{ $t('siteFooter.talentPool') }}</a>
        </div>
        <div class="ljxc item">
          <div class="h1">{{ $t('siteFooter.contact') }}</div>
          <a v-if="isZhLocale" href="https://www.xchr-group.com/contact.html#map" target="_blank" class="h2">{{ $t('siteFooter.map') }}</a>
          <a href="/home/contact-us" target="_blank" class="h2">{{ $t('siteFooter.branch') }}</a>
        </div>
        <div class="ljxc item last-item">
          <div class="h1">{{ $t('siteFooter.legal') }}</div>
          <a :href="agreementLink" :target="agreementTarget" class="h2">{{ $t('siteFooter.agreement') }}</a>
          <a :href="privacyLink" :target="privacyTarget" class="h2">{{ $t('siteFooter.privacy') }}</a>
        </div>
      </div>

      <div class="right">
        <div class="top">
          <div class="f1">
            <div class="item">
              <label for="footer_name">{{ $t('siteFooter.name') }}</label>
              <input id="footer_name" v-model.trim="form.uname" type="text" class="name" />
            </div>
            <div class="item phone_wrapper">
              <label for="footer_phone">{{ $t('siteFooter.contactEmail') }}</label>
              <input id="footer_phone" v-model.trim="form.phone" type="text" class="phone" />
            </div>
          </div>

          <div class="f2">
            <label for="footer_remark">{{ $t('siteFooter.demandPlaceholder') }}</label>
            <textarea id="footer_remark" v-model.trim="form.remark" class="remark" :placeholder="$t('siteFooter.demandPlaceholder')"></textarea>
          </div>
        </div>
        <div class="btn" @click="submit">{{ $t('siteFooter.submit') }}</div>
      </div>
    </div>

    <div class="link section">
      <a class="h2" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">湘ICP备18024568号-4</a>
    </div>

    <div class="bottom"></div>
  </div>
</template>

<script>
import { submitFooterByLocale } from '@/api/collaborator'

export default {
  name: 'SiteFooter',
  data() {
    return {
      submitting: false,
      form: {
        uname: '',
        phone: '',
        remark: ''
      }
    }
  },
  computed: {
    isZhLocale() {
      const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      return locale === 'zh-CN'
    },
    agreementLink() {
      return this.isZhLocale ? 'https://www.xchr-group.com/service.html' : '/home/legal-info?tab=service'
    },
    privacyLink() {
      return this.isZhLocale ? 'https://www.xchr-group.com/private.html' : '/home/legal-info?tab=privacy'
    },
    agreementTarget() {
      return this.isZhLocale ? '_blank' : '_self'
    },
    privacyTarget() {
      return this.isZhLocale ? '_blank' : '_self'
    }
  },
  methods: {
    notify(type, message) {
      if (this.$message) {
        this.$message({ type, message })
      } else {
        window.alert(message)
      }
    },
    async submit() {
      const { uname, phone, remark } = this.form

      if (uname.length < 2 || uname.length > 10) {
        this.notify('warning', this.$t('siteFooter.validateName'))
        return
      }

      if (!phone) {
        this.notify('warning', this.$t('siteFooter.validatePhone'))
        return
      }

      if (!remark) {
        this.notify('warning', this.$t('siteFooter.validateRemark'))
        return
      }

      if (this.submitting) return
      this.submitting = true

      try {
        const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
        await submitFooterByLocale(locale, { uname, phone, remark })

        this.form.uname = ''
        this.form.phone = ''
        this.form.remark = ''
        this.notify('success', this.$t('siteFooter.submitSuccess'))
      } catch (e) {
        this.notify('error', this.$t('siteFooter.submitError'))
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  box-sizing: border-box;
  height: 496px;
  position: relative;
  background: #fff;
}
.footer .section {
  width: 1200px;
  margin: 0 auto;
}
.footer .link-wrapper {
  padding-top: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  text-align: center;
}
.footer .link-wrapper .h1 {
  font-size: 18px;
  color: #000000;
  text-align: left;
}
.footer .link-wrapper .h2 {
  font-size: 16px;
  color: #666666;
  margin-top: 14px;
  text-decoration: none;
  display: block;
}
.footer .link-wrapper .left {
  width: 650px;
  float: left;
}
.footer .link-wrapper .left .ljxc {
  float: left;
  margin-right: 62px;
}
.footer .link-wrapper .left .ljxc.last-item {
  margin-right: 0;
}
.footer .link-wrapper .right {
  float: right;
  margin-left: 100px;
  width: 570px;
  text-align: left;
}
.footer .link-wrapper .right .f1 {
  float: left;
}
.footer .link-wrapper .right .f1 .item {
  cursor: pointer;
  height: 52px;
  border: 1px solid #f7f7f7;
  width: 270px;
  background-color: #f0f0f0;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.footer .link-wrapper .right .f1 .item label {
  cursor: pointer;
  width: 118px;
  flex-shrink: 0;
  color: #666;
  line-height: 1;
  font-size: 13px;
  white-space: nowrap;
}
.footer .link-wrapper .right .f1 .item input {
  border: none;
  flex: 1;
  width: 0;
  min-width: 0;
  height: 100%;
  font-size: 14px;
  line-height: 52px;
  background-color: #f0f0f0;
  outline: none;
  color: #333;
}
.footer .link-wrapper .right .f1 .item.phone_wrapper {
  cursor: pointer;
  margin-top: 12px;
}
.footer .link-wrapper .right .f2 {
  background-color: #f0f0f0;
  width: 289px;
  height: 116px;
  font-size: 14px;
  float: right;
}
.footer .link-wrapper .right .f2 textarea {
  resize: none;
  padding: 12px 14px;
  width: 100%;
  height: 100%;
  border: 1px solid #f0f0f0;
  background-color: #f0f0f0;
  overflow: hidden;
  outline: none;
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}
.footer .link-wrapper .right .f2 label {
  display: none;
}
.footer .link-wrapper .right .top {
  height: 180px;
}
.footer .link-wrapper .right .btn {
  cursor: pointer;
  clear: both;
  width: 96px;
  height: 32px;
  background: #1c51a3;
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
  margin-top: 20px;
  margin-left: 446px;
}
.footer .other {
  font-size: 20px;
  color: #333333;
  text-align: left;
  display: table;
}
.footer .other div {
  display: table-cell;
  vertical-align: middle;
}
.footer .other .item {
  cursor: pointer;
  width: 26px;
  height: 26px;
  margin-left: 16px;
  vertical-align: middle;
}
.footer .other .item.wechat {
  width: 26px;
  height: 22px;
}
.footer .other .item.douyin {
  width: 22px;
  height: 26px;
}
.footer .other .item.weibo {
  width: 24px;
  height: 20px;
}
.footer .other .text {
  display: inline-block;
}
.footer .other .imgWrapper {
  position: relative;
  display: inline-block;
}
.footer .other .imgWrapper .link {
  padding-top: 0;
  position: absolute;
  width: 100px;
  height: 100px;
  left: 50%;
  margin-left: -50px;
  bottom: -120px;
  display: none;
}
.footer .other .imgWrapper:hover .link {
  display: block;
}
.footer .border {
  height: 2px;
  width: 100%;
  background-color: #f2f3f5;
  margin-top: 27px;
  margin-bottom: 40px;
  clear: both;
}
.footer .link {
  padding-top: 17px;
  clear: both;
  text-align: center;
}
.footer .link a {
  color: #666666;
  text-decoration: none;
}
.footer .bottom {
  height: 10px;
  width: 100%;
  background: #1c51a3;
  clear: both;
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
